import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, ArrowRight } from 'lucide-react';
export function Slide7Summary() {
  const achievements = [{
    outcome: 'Lead Generation',
    result: '12 qualified leads',
    impact: '2-3x industry conversion rates'
  }, {
    outcome: 'Brand Engagement',
    result: '73 exposures, 4.5 min average',
    impact: '2.85x industry engagement'
  }, {
    outcome: 'Market Intelligence',
    result: 'Comprehensive perception data',
    impact: 'Competitive advantage unlocked'
  }, {
    outcome: 'Existing Customer Value',
    result: 'Perception gaps identified',
    impact: 'Retention & expansion opportunity'
  }, {
    outcome: 'Replicable Model',
    result: 'Proven framework established',
    impact: 'Scalable growth path'
  }];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-718">
      <div className="mb-8 border-b border-slate-100 pb-6 text-center" data-id="element-719">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-720">
          08 / Conclusion
        </div>
        <h2 className="text-5xl font-display font-bold text-slate-900 mb-2" data-id="element-721">
          Success Summary & Recommendation
        </h2>
        <p className="text-xl text-slate-500 max-w-3xl mx-auto" data-id="element-722">
          The foundation is solid. The opportunity is significant. The data
          supports growth.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 flex-1 items-stretch [&>*:first-child]:flex [&>*:first-child]:flex-col [&>*:first-child]:justify-center" data-id="element-723">
        {/* What This Campaign Achieved */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm" data-id="element-724">
          <div className="flex items-center gap-3 mb-4" data-id="element-725">
            <div className="p-2.5 bg-amber-100 rounded-xl" data-id="element-726">
              <Trophy className="w-5 h-5 text-amber-600" data-id="element-727" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-728">
              What This Campaign Achieved
            </h3>
          </div>

          <div className="space-y-3" data-id="element-729">
            {achievements.map((item, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 gap-2" data-id="element-730">
                <div className="font-bold text-slate-800 text-sm w-1/3" data-id="element-731">
                  {item.outcome}
                </div>
                <div className="text-minerva-blue font-semibold text-sm w-1/3" data-id="element-732">
                  {item.result}
                </div>
                <div className="text-xs text-slate-500 w-1/3 text-right" data-id="element-733">
                  {item.impact}
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* Strategic Recommendation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-minerva-dark rounded-3xl p-8 border border-minerva-blue/20 shadow-xl text-white flex flex-col justify-center relative overflow-hidden" data-id="element-734">
          <div className="absolute top-0 right-0 w-64 h-64 bg-minerva-blue/10 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-735" />

          <h3 className="text-2xl font-display font-bold text-white mb-4 relative z-10" data-id="element-736">
            Strategic Recommendation
          </h3>

          <div className="space-y-4 relative z-10 text-base text-white/90 leading-relaxed" data-id="element-737">
            <p data-id="element-738">
              This campaign was a{' '}
              <strong className="text-minerva-cyan" data-id="element-739">clear success</strong>.
              Minerva achieved exceptional results on lead generation, brand
              engagement, and market research.
            </p>
            <div className="bg-white/10 p-5 rounded-2xl border border-white/20 mt-2" data-id="element-740">
              <p className="font-semibold flex items-start gap-3 text-sm" data-id="element-741">
                <ArrowRight className="w-5 h-5 text-minerva-cyan shrink-0" data-id="element-742" />
                The expansion path is compelling: reuse a proven,
                high-performing model to multiply lead volume while reducing
                cost per lead by 60-70%.
              </p>
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-white/10 flex justify-between text-xs font-medium text-white/60 relative z-10" data-id="element-743">
            <span data-id="element-744">Decision Timeline: Two weeks</span>
            <span data-id="element-745">Expansion Window: Ready to launch Phase 2</span>
          </div>
        </motion.div>
      </div>
    </div>;
}